import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Util from 'utility';
import api from 'api';
import { addFoodModification, removeFoodModification } from 'actions/index';
import { __ } from 'locale';

function LectureTaskPanelFoodModifications({ food }) {
    const data = useSelector(state => state);
    const dispatch = useDispatch();
    const { globals } = data;
    const [helpItem, setHelpItem] = useState(null);

    const foodModificationToggle = (e, foodId) => {
        if (e.target.checked) {
            dispatch(addFoodModification({ foodId, modificationId: e.target.value }));
        } else {
            dispatch(removeFoodModification({ foodId, modificationId: e.target.value }));
        }
        Util.doLoadDayEvaluation();
    };

    const showModificationHelp = (prepId) => {
        api('modification-help/' + prepId).then(result => {
            result = result.data;
            if (!result.error) setHelpItem(result);
        });
    };

    if (helpItem) {
        return (
            <div className="p-1">
                <button
                    className="inline-flex items-center gap-1.5 text-sm text-green-600 hover:text-green-700 mb-4 cursor-pointer"
                    onClick={() => setHelpItem(null)}
                >
                    <i className="fa fa-arrow-left text-xs"></i>
                    Zpět na úpravy
                </button>
                <h2 className="text-lg font-bold text-slate-800 mb-3">{helpItem.title}</h2>
                <div
                    className="text-sm text-slate-600 leading-relaxed [&>p]:mb-3 [&>ul]:pl-5 [&>ul]:mb-3 [&>ul>li]:mb-1"
                    dangerouslySetInnerHTML={{ __html: helpItem.description }}
                />
            </div>
        );
    }

    const foodMods = data.modifications[food.id];
    const disableUnchecked = foodMods && foodMods.length >= 999;
    const selectedCount = foodMods ? foodMods.length : 0;

    const sortedPreparationIds = Object.values(globals.preparation_type_ids_sorted)
        .filter(prepId => prepId != 0)
        .sort((a, b) => globals.preparation_types[a].localeCompare(globals.preparation_types[b], 'cs', { sensitivity: 'base' }));

    const modList = sortedPreparationIds.map(prepId => {
        const checked = foodMods ? foodMods.indexOf(prepId) > -1 : false;
        const cbName = `cb_${food.id}_[]`;
        const prepUniqId = `prep_${food.id}_${prepId}`;
        const label = globals.preparation_types[prepId];
        const dimmed = disableUnchecked && !checked;

        return (
            <div key={prepId} className="relative">
                <input
                    type="checkbox"
                    name={cbName}
                    id={prepUniqId}
                    value={prepId}
                    checked={checked}
                    onChange={e => foodModificationToggle(e, food.id)}
                    className="hidden peer"
                />
                <label
                    htmlFor={prepUniqId}
                    className={`flex flex-col items-center gap-2 p-3 pt-4 rounded-xl border-2 cursor-pointer transition-all select-none
                        peer-checked:bg-green-50 peer-checked:border-green-400 peer-checked:text-green-700
                        ${dimmed
                            ? 'opacity-35 border-slate-100 bg-slate-50 cursor-not-allowed'
                            : 'border-slate-200 bg-white hover:border-slate-300 hover:bg-slate-50 text-slate-700'
                        }`}
                >
                    <img
                        className="w-9 h-9 shrink-0"
                        src={`https://www.zofapp.cz/data/zof/modifications/${prepId}.svg`}
                        alt=""
                    />
                    <span className="text-xs text-center leading-tight font-medium">{label}</span>
                </label>

                {checked && (
                    <div className="absolute top-1.5 left-1.5 w-4 h-4 bg-green-500 rounded-full flex items-center justify-center pointer-events-none">
                        <i className="fa fa-check text-white" style={{ fontSize: '8px' }}></i>
                    </div>
                )}

                {!disableUnchecked && (
                    <button
                        type="button"
                        className="absolute top-1.5 right-1.5 w-4 h-4 rounded-full border border-slate-200 bg-white text-slate-300 hover:border-green-400 hover:text-green-500 flex items-center justify-center transition-colors"
                        style={{ fontSize: '9px' }}
                        onClick={() => showModificationHelp(prepId)}
                        title="Nápověda"
                    >
                        ?
                    </button>
                )}
            </div>
        );
    });

    return (
        <div className="p-1">
            {/* Food context */}
            <div className="flex items-center gap-3 mb-4 pb-4 border-b border-slate-100">
                {food.image && (
                    <img src={food.image} alt="" className="w-10 h-10 object-contain shrink-0" />
                )}
                <div>
                    <p className="text-sm font-semibold text-slate-800 m-0">{food.title}</p>
                    {selectedCount > 0 && (
                        <p className="text-xs text-green-600 m-0 mt-0.5">
                            {selectedCount === 1 ? `1 ${__('úprava vybrána')}` : `${selectedCount} ${__('úpravy vybrány')}`}
                        </p>
                    )}
                    {selectedCount === 0 && (
                        <p className="text-xs text-slate-400 m-0 mt-0.5">{__('Žádná úprava nevybrána')}</p>
                    )}
                </div>
            </div>

            {/* Grid of modifications */}
            <div className="grid grid-cols-4 gap-2">
                {modList}
            </div>
        </div>
    );
}

export default LectureTaskPanelFoodModifications;
